import { institutesDetails } from "../top_engineering_college_in_indore/constant";
import { Link } from "react-router-dom";

const Course_Card = ({ id }) => {
  return (
    <div
      style={{
        background: "#eaeaea",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
      id={id}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
        Top Engineering Courses Provided by Us
      </h2>

      <div className="course-wrapper">
        {institutesDetails.map((institute) => (
          <Link
            to={`${institute.instituteLink}`}
            key={institute._id}
            className="course-card"
          >
            <img
              style={{ width: "100px",  marginBottom: "10px" }}
              src={institute.instituteImage}
              alt="course icon"
            />
            <p style={{ margin: 0, color: "black" }}>
              {institute.instituteName}
            </p>
          </Link>
        ))}
      </div>

      <style>
        {`
          .course-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 20px;
          }

          .course-card {
            width: calc(25% - 20px);
            background: #ffffff;
            height: 200px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 6px rgba(0,0,0,0.1);
            border-radius: 8px;
            transition: transform 0.3s ease;
          }

          .course-card:hover {
            animation: bounce 0.6s;
          }

          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          @media (max-width: 1024px) {
            .course-card {
              width: calc(33.33% - 20px);
            }
          }

          @media (max-width: 768px) {
            .course-card {
              width: calc(50% - 20px);
            }
          }

          @media (max-width: 500px) {
            .course-card {
              width: calc(100% - 20px);
            }
            .course-wrapper {
              justify-content: center !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Course_Card;
